<template lang="pug">
.neutral200
  range-dropdown.mt-2(v-if="dates")
  //- Marketing Sales
  div
    v-row(no-gutters)
      v-col.py-2(cols="12" md="4" :class="[{ 'pr-2': !isMobileScreen }]")
        v-card.border.round-lg.pa-6(outlined)
          div.text-sm.font-medium.neutral500--text Additional sales generated
          div.d-flex.mt-4.mb-1(v-if="isFetchingMarketingSales")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g5.mt-4(v-else) {{ marketingSales.total_sales | displayPrice($currency) }}
      v-col.py-2(cols="12" md="4" :class="[{ 'px-2': !isMobileScreen }]")
        v-card.border.round-lg.pa-6(outlined)
          div.text-sm.font-medium.neutral500--text Sales from loyalty program
          div.d-flex.mt-4.mb-1(v-if="isFetchingMarketingSales")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g5.mt-4(v-else) {{ marketingSales.loyalty_sales | displayPrice($currency) }}
      v-col.py-2(cols="12" md="4" :class="[{ 'pl-2': !isMobileScreen }]")
        v-card.border.round-lg.pa-6(outlined)
          div.text-sm.font-medium.neutral500--text Sales from offers campaign
          div.d-flex.mt-4.mb-1(v-if="isFetchingMarketingSales")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g5.mt-4(v-else) {{ marketingSales.offer_sales | displayPrice($currency) }}

  overview-sales-comparison(ref="salescomparison")

  v-divider.my-6
  //- Offers Performance
  div
    div.d-flex(:class="[{ 'flex-column': isMobileScreen }, isMobileScreen ? 'align-start' : 'align-center']")
      div.text-xl.font-semibold.neutral700--text(:class="[{ 'mb-4': isMobileScreen }]") Your overall offers performance
      v-spacer
      div(style="max-width: 200px;")
        y-select(v-model="offer" small placeholder="Select campaign" attach :items="offers" item-text="name" item-value="id" :loading="isFetchingOfferStats" @change="fetchOfferStats")
    v-row.mt-4(no-gutters)
      v-col.py-2
        v-card.border.round-lg.pa-6(outlined)
          div.text-sm.font-medium.neutral500--text Redemption revenue
          div.d-flex.mt-4.mb-1(v-if="isFetchingOfferStats")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g5.mt-4(v-else) {{ offerStats.redemption_revenue | displayPrice($currency) }}
    v-row(no-gutters)
      v-col.py-2(cols="12" md="4" :class="[{ 'pr-2': !isMobileScreen }]")
        v-card.border.round-lg.pa-6(outlined)
          div.text-sm.font-medium.neutral500--text Total successful SMS sent
          div.d-flex.mt-4.mb-1(v-if="isFetchingOfferStats")
            v-progress-circular(:width="5" :size="68" color="neutral500" indeterminate)
          template(v-else-if="offerStats.sms")
            div.text-g5.mt-4 {{ offerStats.sms.total_sent | displayNumber }}
            div.text-sm.font-medium.neutral500--text {{ Math.floor((Number(offerStats.sms.total_sent) * 100)/Number(offerStats.sms.total_blasted)) }}% successful rate
            div.text-sm.neutral700--text {{ offerStats.sms.total_sent }} out of {{ offerStats.sms.total_blasted }} customers received the offer
      v-col.py-2(cols="12" md="4" :class="[{ 'px-2': !isMobileScreen }]")
        v-card.border.round-lg.pa-6(outlined)
          div.text-sm.font-medium.neutral500--text Total successful email sent
          div.d-flex.mt-4.mb-1(v-if="isFetchingOfferStats")
            v-progress-circular(:width="5" :size="68" color="neutral500" indeterminate)
          template(v-else-if="offerStats.email")
            div.text-g5.mt-4 {{ offerStats.email.total_sent | displayNumber }}
            div.text-sm.font-medium.neutral500--text {{ Math.floor((Number(offerStats.email.total_sent) * 100)/Number(offerStats.email.total_blasted)) }}% successful rate
            div.text-sm.neutral700--text {{ offerStats.email.total_sent }} out of {{ offerStats.email.total_blasted }} customers received the offer
      v-col.py-2(cols="12" md="4" :class="[{ 'pl-2': !isMobileScreen }]")
        v-card.border.round-lg.pa-6(outlined)
          div.text-sm.font-medium.neutral500--text Total successful WhatsApp sent
          div.d-flex.mt-4.mb-1(v-if="isFetchingOfferStats")
            v-progress-circular(:width="5" :size="68" color="neutral500" indeterminate)
          template(v-else-if="offerStats.whatsapp")
            div.text-g5.mt-4 {{ offerStats.whatsapp.total_sent | displayNumber }}
            div.text-sm.font-medium.neutral500--text {{ Math.floor((Number(offerStats.whatsapp.total_sent) * 100)/Number(offerStats.whatsapp.total_blasted)) }}% successful rate
            div.text-sm.neutral700--text {{ offerStats.whatsapp.total_sent }} out of {{ offerStats.whatsapp.total_blasted }} customers received the offer
    v-row(no-gutters)
      v-col.py-2(cols="6" md="" :class="[isMobileScreen ? 'pr-1' : 'pr-2']")
        v-card.border.round-lg.pa-6(outlined height="100%")
          div.text-sm.font-medium.neutral500--text Active campaign
          div.d-flex.mt-4.mb-1(v-if="isFetchingOfferStats")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g5.mt-4(v-else) {{ offerStats.active_campaigns | displayNumber }}
      v-col.py-2(cols="6" md="" :class="[isMobileScreen ? 'pl-1' : 'px-2']")
        v-card.border.round-lg.pa-6(outlined height="100%")
          div.text-sm.font-medium.neutral500--text Total customers engaged
          div.d-flex.mt-4.mb-1(v-if="isFetchingOfferStats")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g5.mt-4(v-else) {{ offerStats.total_audiences | displayNumber }}
      v-col.py-2(cols="6" md="" :class="[isMobileScreen ? 'pr-1' : 'px-2']")
        v-card.border.round-lg.pa-6(outlined height="100%")
          div.text-sm.font-medium.neutral500--text Total code issued
          div.d-flex.mt-4.mb-1(v-if="isFetchingOfferStats")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g5.mt-4(v-else) {{ offerStats.total_code_issued | displayNumber }}
      v-col.py-2(cols="6" md="" :class="[isMobileScreen ? 'pl-1' : 'px-2']")
        v-card.border.round-lg.pa-6(outlined height="100%")
          div.text-sm.font-medium.neutral500--text Total offers/code redeemed
          div.d-flex.mt-4.mb-1(v-if="isFetchingOfferStats")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g5.mt-4(v-else) {{ offerStats.total_redeemed | displayNumber }}
      v-col.py-2(cols="6" md="" :class="[isMobileScreen ? 'pr-1' : 'pl-2']")
        v-card.border.round-lg.pa-6(outlined height="100%")
          div.text-sm.font-medium.neutral500--text Redemption rate
          div.d-flex.mt-4.mb-1(v-if="isFetchingOfferStats")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g5.mt-4(v-else) {{ Math.floor((Number(offerStats.total_redeemed) * 100)/Number(offerStats.total_code_issued)) }}%

  v-divider.my-6
  //- Loyalty Performance
  div
    div.text-xl.font-semibold.neutral700--text Your overall loyalty performance
    v-row.mt-4(no-gutters)
      v-col.py-2(cols="12" md="3" :class="[{ 'pr-2':!isMobileScreen }]")
        v-card.border.round-lg.pa-6(outlined)
          div.text-sm.font-medium.neutral500--text Total generated value from loyalty
          div.d-flex.mt-4.mb-1(v-if="isFetchingLoyaltyOverview")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g5.mt-4(v-else) {{ loyaltyOverview.total_sales | displayPrice($currency) }}
          v-divider.my-4
          div.text-sm.font-medium.neutral500--text Number of members ready for rewards
          div.d-flex.mt-4.mb-1(v-if="isFetchingLoyaltyOverview")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g5.mt-4(v-else style="margin-bottom: 33px;") {{ Math.floor(loyaltyOverview.has_reward_members) }}
      v-col.py-2(cols="12" md="3" :class="[{ 'px-2':!isMobileScreen }]")
        v-card.border.round-lg.pa-6(outlined)
          div.text-sm.font-medium.neutral500--text Count of repeating purchases
          div.d-flex.mt-4.mb-1(v-if="isFetchingLoyaltyOverview")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g5.mt-4(v-else-if="loyaltyOverview.repeating_purchases") {{ loyaltyOverview.repeating_purchases.count | displayNumber }}
          v-divider.my-4
          div.text-sm.font-medium.neutral500--text Sales for repeating purchases
          div.d-flex.mt-4.mb-1(v-if="isFetchingLoyaltyOverview")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g5.mt-4(v-else-if="loyaltyOverview.repeating_purchases" style="margin-bottom: 33px;") {{ loyaltyOverview.repeating_purchases.sales | displayPrice($currency) }}
      v-col.py-2(cols="12" md="3" :class="[{ 'px-2':!isMobileScreen }]")
        v-card.border.round-lg.pa-6(outlined)
          div.text-sm.font-medium.neutral500--text Count of first purchases
          div.d-flex.mt-4.mb-1(v-if="isFetchingLoyaltyOverview")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g5.mt-4(v-else-if="loyaltyOverview.first_purchases") {{ loyaltyOverview.first_purchases.count | displayNumber }}
          v-divider.my-4
          div.text-sm.font-medium.neutral500--text Sales for first purchases
          div.d-flex.mt-4.mb-1(v-if="isFetchingLoyaltyOverview")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g5.mt-4(v-else-if="loyaltyOverview.first_purchases" style="margin-bottom: 33px;") {{ loyaltyOverview.first_purchases.sales | displayPrice($currency) }}
      v-col.py-2(cols="12" md="3" :class="[{ 'pl-2':!isMobileScreen }]")
        v-card.border.round-lg.pa-6(outlined)
          div.text-sm.font-medium.neutral500--text Registered members
          div.d-flex.mt-2.mb-1(v-if="isFetchingLoyaltyOverview")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g7.blue500--text.mt-2(v-else) {{ loyaltyOverview.registered_members | displayNumber }}
          v-divider.my-2
          div.text-sm.font-medium.neutral500--text(v-if="settings && settings.loyalty_system === 'stamps'") Stamps issued
          div.text-sm.font-medium.neutral500--text(v-if="settings && settings.loyalty_system === 'points'") Points collected
          div.d-flex.mt-2.mb-1(v-if="isFetchingLoyaltyOverview")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g7.mt-2(v-else) {{ loyaltyOverview.collected_count | displayNumber }}
          v-divider.my-2
          div.text-sm.font-medium.neutral500--text Rewards redeemed
          div.d-flex.mt-2.mb-1(v-if="isFetchingLoyaltyOverview")
            v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div.text-g7.success500--text.mt-2(v-else) {{ loyaltyOverview.redeemed_count | displayNumber }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import axios from 'axios'
import OverviewSalesComparison from '@/components/clinic/marketing/OverviewSalesComparison.vue'
import RangeDropdown from '@/components/clinic/marketing/filters/RangeDropdown.vue'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import DeleteConfirmationDialog from '@/components/clinic/dialogs/DeleteConfirmationDialog.vue'

export default {
  components: { OverviewSalesComparison, RangeDropdown, CustomizeColumnMenu, DeleteConfirmationDialog },
  data: () => ({
    isFetchingMarketingSales: false,
    isFetchingOfferStats: false,
    isFetchingLoyaltyOverview: false,
    cancelledRequest: false,
    offer: null,
    source: null,
    offers: [{ id: null, name: 'All offers' }],
    marketingSales: {},
    offerStats: {},
    loyaltyOverview: {},
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      settings: 'marketing/getMarketingSettings',
      dates: 'marketing/getDates',
      beginDate: 'marketing/getBeginDate',
      untilDate: 'marketing/getUntilDate',
      currentDateRange: 'marketing/getCurrentDateRange'
    }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
  },
  watch: {
    dates () {
      this.fetchOverviews()
    },
  },
  created () {
    this.setupDates()
  },
  mounted () {
    this.fetchOffers()
    this.fetchOverviews()
  },
  methods: {
    ...mapActions(['showMessage']),
    setupDates () {
      if (this.dates) {
        // this.fetchOverviews()
        return
      }
      const now = DateTime.local()
      const dateFormat = 'yyyy-MM-dd'
      const start = now.minus({ days: 6 })
      this.$store.commit('marketing/setDates', [start.toFormat(dateFormat), now.toFormat(dateFormat)])
    },
    fetchOverviews () {
      this.source = axios.CancelToken.source()
      this.$nextTick(() => {
        this.fetchMarketingSales()
        this.fetchOfferStats()
        this.fetchLoyaltyOverview()
      })
    },
    fetchMarketingSales () {
      this.isFetchingMarketingSales = true
      let params = {
        begin: this.beginDate,
        until: this.untilDate,
      }
      this.$axios.get(`/marketing/${this.company.slug}/sales`, { params, cancelToken: this.source.token })
        .then(resp => {
          this.marketingSales = resp.data
          this.cancelledRequest = false
        })
        .catch(() => {
          this.cancelledRequest = true
        })
        .finally(() => {
          this.isFetchingMarketingSales = false
        })
    },
    fetchOfferStats () {
      this.isFetchingOfferStats = true
      let params = {
        type: 'campaign',
        ids: this.offer
      }
      this.$axios.get(`/marketing/${this.company.slug}/offers/stats`, { params, cancelToken: this.source.token })
        .then(resp => {
          this.offerStats = resp.data
          this.cancelledRequest = false
        })
        .catch(() => {
          this.cancelledRequest = true
        })
        .finally(() => {
          this.isFetchingOfferStats = false
        })
    },
    fetchLoyaltyOverview () {
      this.isFetchingLoyaltyOverview = true
      let params = {
        begin: this.beginDate,
        until: this.untilDate,
        // range: rangeValueFromPeriod(this.currentDateRange?.id)
      }
      this.$axios.get(`/loyalty/${this.company.slug}/overview`, { params, cancelToken: this.source.token })
        .then(resp => {
          this.loyaltyOverview = resp.data
          this.cancelledRequest = false
        })
        .catch(() => {
          this.cancelledRequest = true
        })
        .finally(() => {
          this.isFetchingLoyaltyOverview = false
        })
    },
    fetchOffers () {
      this.isFetchingOffers = true
      let params = {
        type: 'campaign',
        fields: 'id,name',
        page_size: -1
      }
      this.$axios.get(`/marketing/${this.company.slug}/offers`, { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            let offers = resp.data.results
            offers.unshift({ id: null, name: 'All offers' })
            this.offers = offers
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingOffers = false
        })
    },
    cancelRequest () {
      this.source.cancel()
      this.$refs.salescomparison.cancelRequest()
      // console.log('Request has been cancelled')
    },
  }
}
</script>

<style scoped>
</style>